import { render, staticRenderFns } from "./map-edit-location.vue?vue&type=template&id=56c446ab&scoped=true"
import script from "./map-edit-location.vue?vue&type=script&lang=js"
export * from "./map-edit-location.vue?vue&type=script&lang=js"
import style0 from "./map-edit-location.vue?vue&type=style&index=0&id=56c446ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c446ab",
  null
  
)

export default component.exports